import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PriceInputProps {
  value: number;
  onChange: (value: number) => void;
}

const PriceInput = ({ value, onChange }: PriceInputProps) => {
  return (
    <div>
      <Label htmlFor="price">Price per Hour</Label>
      <Input
        id="price"
        type="number"
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
      />
    </div>
  );
};

export default PriceInput;